export default "__VITE_ASSET__a6842aea__"